import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import Small from 'UIComponents/elements/Small';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import ApprovalUserFormattedName from '../ApprovalUserFormattedName';
import ApprovalNote from './ApprovalNote';
import FormattedDate from './FormattedDate';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalRequestNote() {
  const approval = useApprovalContext();
  if (!approval.data) {
    return null;
  }
  const {
    requester,
    createDateTimestamp,
    requestNote
  } = approval.data;
  if (!requestNote) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "productApprovals.ApprovalRequestNote.summary",
          options: {
            requesterFullName: /*#__PURE__*/_jsx(ApprovalUserFormattedName, {
              approvalUser: requester
            }),
            timestamp: /*#__PURE__*/_jsx(FormattedDate, {
              date: createDateTimestamp
            })
          }
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "m-top-1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestNote.emptyNote"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(ApprovalNote, {
    approvalUser: requester,
    timestamp: createDateTimestamp,
    note: requestNote
  });
}
export default ApprovalRequestNote;